import script from "./MainMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./MainMenu.vue?vue&type=script&lang=ts&setup=true"

import "./MainMenu.vue?vue&type=style&index=0&id=4e705efc&lang=scss&scoped=true"

import exportComponent from "/builds/rentalcar-app/admin-v3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e705efc"]])

export default __exports__